<template>
  <div class="auth-main v1">
    <div class="auth-wrapper">
      <div class="auth-form">
        <div class="card my-5">
          <div class="card-body">
            <div class="text-center">
              <img src="/src/assets/images/authentication/img-auth-login.png" alt="images" class="img-fluid mb-3" />
              <h4 class="f-w-500 mb-1">{{ $t('auth.emailVerification.title') }}</h4>
              <p class="mb-3">{{ $t('auth.emailVerification.subtitle') }}</p>
            </div>
            
            <!-- Loading state -->
            <div v-if="isLoading" class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-3">{{ $t('auth.emailVerification.verifying') }}</p>
            </div>
            
            <!-- Success message -->
            <div v-else-if="verificationSuccess" class="alert alert-success text-center" role="alert">
              <i class="fas fa-check-circle fa-2x mb-3"></i>
              <h5>{{ $t('auth.emailVerification.success') }}</h5>
              <p>{{ $t('auth.emailVerification.successMessage') }}</p>
              <router-link to="/login" class="btn btn-primary mt-3">
                {{ $t('auth.emailVerification.goToLogin') }}
              </router-link>
            </div>
            
            <!-- Error message -->
            <div v-else-if="error" class="alert alert-danger text-center" role="alert">
              <i class="fas fa-times-circle fa-2x mb-3"></i>
              <h5>{{ $t('auth.emailVerification.error') }}</h5>
              <p>{{ error }}</p>
              <router-link to="/login" class="btn btn-secondary mt-3">
                {{ $t('auth.emailVerification.backToLogin') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import authService from '@/services/authService';

export default {
  name: 'EmailVerificationPage',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    
    const isLoading = ref(false);
    const verificationSuccess = ref(false);
    const error = ref(null);

    const verifyEmail = async (token) => {
      if (!token) {
        error.value = t('auth.emailVerification.invalidToken');
        return;
      }


      
      isLoading.value = true;
      error.value = null;

      try {
        const result = await authService.verifyEmail(token);
        
        if (result) {
          verificationSuccess.value = true;
          
          // Show success notification
          store.dispatch('notify', {
            message: t('auth.emailVerification.verificationSuccess'),
            type: 'success'
          });
        } else {
          error.value = t('auth.emailVerification.verificationFailed');
        }
      } catch (err) {
        console.error('Email verification error:', err);
        console.error('Error response:', err.response?.data);
        error.value = err.response?.data?.message || t('auth.emailVerification.verificationError');
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      const token = route.query.token;

      
      if (token) {
        verifyEmail(token);
      } else {
        error.value = t('auth.emailVerification.noToken');
      }
    });

    return {
      isLoading,
      verificationSuccess,
      error
    };
  }
};
</script> 